import { Entity } from '@api';
import { SendAllAssetsTo } from '@terminal/components/send-all-assets-to/SendAllAssetsTo';
import { ConnectionsEmptyOrError } from '@terminal/modules/overview-knowledge-graph/components/shared/section-base/SectionBase';
import { useTranslation } from 'react-i18next';
import { useCompetitorsData } from '../../hooks/useCompetitorsData';
import { RankingMethodologySection } from '../theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import styles from './CompetitorsTab.module.scss';
import { CompetitorsTable } from './competitors-table/CompetitorsTable';

interface CompetitorsTabProps {
  entity: Entity;
}

export const CompetitorsTab = ({ entity }: CompetitorsTabProps) => {
  const { t } = useTranslation(['widget']);

  const { tableData, columnsMeta, isError, isEmpty, isFetching } =
    useCompetitorsData({
      entityTag: entity.tag,
    });

  const displayedEntityTags = tableData
    .filter(row => row.hasData)
    .map(row => row.entity?.tag) as string[];

  if (isError) {
    return (
      <div className={styles.stateRoot}>
        <ConnectionsEmptyOrError variant="error" errorSize="fullView" />
        <RankingMethodologySection rankingType="competitorsToTheme" />
      </div>
    );
  }

  if (isEmpty && !isFetching) {
    return (
      <div className={styles.stateRoot}>
        <ConnectionsEmptyOrError
          variant="empty"
          layout="fillContainer"
          imageSize="full"
          title={t(
            'widget:assetOverview.knowledgeGraphRevamp.empty.competitors'
          )}
        />
        <RankingMethodologySection rankingType="competitorsToTheme" />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {!!displayedEntityTags.length && (
        <div className={styles.menuBar}>
          <div className={styles.assetsCounter}>
            {t(
              'widget:assetOverview.knowledgeGraph.competitors.assetsCounter',
              {
                count: displayedEntityTags.length,
              }
            )}
          </div>
          <SendAllAssetsTo
            entityTags={displayedEntityTags}
            source="asset_overview"
          />
        </div>
      )}
      <div className={styles.scrollContainer}>
        <CompetitorsTable
          tableData={tableData}
          columnsMeta={columnsMeta}
          isFetching={isFetching}
        />
      </div>
    </div>
  );
};
